module.exports = __webpack_public_path__ + "media/images/2-5b74ba3fdf68d5d0037afdacf356c256.jpg";